###
  Dynamic creative widget
###

class INTENT.widgets.DynCreative

  @ATTR_NAME: "data-widget-dyncreative"

  @ATTR_FORM: "#{@ATTR_NAME}-form"
  @ATTR_FIELD_SITE_LOGO: "#{@ATTR_FORM}-sitelogo"

  @ATTR_BTN: "#{@ATTR_NAME}-button"
  @ATTR_BTN_UPLOAD_SITE_LOGO: "#{@ATTR_BTN}-sitelogo"

  @ATTR_CONTAINER: "#{@ATTR_NAME}-container"
  @ATTR_CONTAINER_SITE_LOGO: "#{@ATTR_CONTAINER}-sitelogo"
  @ATTR_CONTAINER_PROGRESS: "#{@ATTR_CONTAINER}-progress"

  @ATTR_PROGRESS_BAR: "#{@ATTR_CONTAINER_PROGRESS}-bar"
  @ATTR_PROGRESS_DESCRIPTION: "#{@ATTR_CONTAINER_PROGRESS}-description"

  constructor: (@el) ->
    @s = @.constructor

    @form = @el.find "[#{@s.ATTR_FORM}]"
    @field_site_logo = @form.find "[#{@s.ATTR_FIELD_SITE_LOGO}]"
    @btn_site_logo = @el.find "[#{@s.ATTR_BTN_UPLOAD_SITE_LOGO}]"
    @container_site_logo = @el.find "[#{@s.ATTR_CONTAINER_SITE_LOGO}]"
    @container_progress = @el.find "[#{@s.ATTR_CONTAINER_PROGRESS}]"

    @init_basic_file_uploader();

  set_site_logo: (http_file_url) =>
    # @container_site_logo.attr 'href', http_file_url
    INTENT.utils.Forms.enable_submit_buttons()
    image = @container_site_logo.find 'img'
    image.attr 'src', http_file_url
    image.on 'load', =>
      @container_site_logo.fadeIn 'fast'
      image.fadeIn 'fast'

  init_basic_file_uploader: () =>
    @uploader = new qq.FileUploaderBasic({
      button: @btn_site_logo[0],
      action: '/campaigns/upload_image',
      debug: true,
      inputName: 'image',
      encoding: 'multipart',
      multiple: false,
      onSubmit: @on_upload_submit,
      onUpload: @on_upload,
      onProgress: @on_upload_progress,
      onComplete: @on_upload_complete,
      onError: @on_upload_error
    })

  on_upload_submit: =>
    @container_site_logo.fadeIn 'fast'
    INTENT.utils.Forms.disable_submit_buttons()
    @container_site_logo.find('img').hide()
    @container_site_logo.find('.loader').show()

  on_upload: (id, fileName) =>
    # console.log id, fileName

  on_upload_progress: (id, fileName, loaded, total) =>
    percent = 0
    if loaded < total
      percent = Math.round(loaded / total * 100)

  on_upload_complete: (id, fileName, responseJSON) =>
    file_url = responseJSON.url
    http_file_url = 'https://' + file_url

    @container_site_logo.fadeOut()
    @set_site_logo http_file_url
    @field_site_logo.attr 'value', file_url
    @container_site_logo.find('.loader').hide()

  on_upload_error: (id, name, reason, xhr) =>
    INTENT.utils.Forms.enable_submit_buttons()
    @container_site_logo.find('.loader').hide()
    return false

